import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Zooquaria = ({ data }) => {
  const getImageUrl = (item) => {
    const image = getImage(item.Cover.localFile);
    return image ? image.images.fallback.src : "";
  };
  const featuredZoos = data.ZooquariaGroup.filter((zoo) => zoo.Featured);
  const nonFeaturedZoos = data.ZooquariaGroup.filter((zoo) => !zoo.Featured);

  return (
    <>
      {featuredZoos.map((zoo, index) => (
        <div
          key={index}
          className={`lg:p-0 p-4 lg:max-w-screen-xl xxl:max-w-screen-3xl mx-auto my-6`}
        >
          <section
            className="my-8 gap-16 lg:max-w-screen-xl xxl:max-w-screen-3xl mx-auto lg:flex items-center p-8 border border-gray200 rounded-lg"
            style={{
              boxShadow: "0px 24px 64px 0px rgba(224, 224, 224, 0.48)",
            }}
          >
            <a
              href={zoo.Url ? zoo.Url : zoo.PDF.localFile.url}
              target="_blank"
              rel="noopener noreferrer"
              className="relative z-10 overflow-hidden w-full h-auto"
              aria-label={zoo.Title}
            >
              <GatsbyImage
                image={getImage(zoo.Cover.largeimage)}
                alt={zoo.Title}
              />
            </a>
            <div className="flex flex-col gap-8 my-8 sm:my-0">
              <p className="text-blue font-bold font-display text-base">
                {zoo.Volume}
              </p>
              <h4 className="text-[24px] font-bold font-display">
                {zoo.Title}
              </h4>
              <p className="text-gray text-lg">{zoo.FeaturedText}</p>
              <p className="text-gray600 font-medium text-sm">{zoo.Date}</p>
            </div>
          </section>
        </div>
      ))}

      {/* Render non-featured zoos in a 3-column grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-5 mx-auto max-w-screen-xl xxl:max-w-screen-3xl lg:p-0 p-4 my-6">
        {nonFeaturedZoos.map((zoo, index) => (
          <div
            key={index}
            className="flex items-center bg-white border border-gray200 rounded-lg flex-row gap-5 p-5"
            style={{
              boxShadow: "0px 24px 64px 0px rgba(224, 224, 224, 0.48)",
            }}
          >
            <a
              href={zoo.Url ? zoo.Url : zoo.PDF.localFile.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
              className="relative z-10 overflow-hidden min-w-32 max-w-32  h-auto"
              aria-label={zoo.Title}
            >
              <GatsbyImage
                image={getImage(zoo.Cover.smallimage)}
                alt={zoo.Title}
              />
            </a>
            <div className="flex flex-col justify-between leading-normal xl:my-0 my-4 gap-4">
              <a
                href={zoo.Url ? zoo.Url : zoo.PDF.localFile.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <p className="text-blue font-bold font-display text-base">
                  {zoo.Volume}
                </p>
                <h4 className="text-lg font-bold font-display tracking-[-0.02em]">
                  {zoo.Title}
                </h4>
                <p className="text-gray600 font-medium text-sm">{zoo.Date}</p>
              </a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Zooquaria;
